import { render, staticRenderFns } from "./gradeModify.vue?vue&type=template&id=25e7c3bf&scoped=true"
import script from "./gradeModify.vue?vue&type=script&lang=ts"
export * from "./gradeModify.vue?vue&type=script&lang=ts"
import style0 from "./gradeModify.vue?vue&type=style&index=0&id=25e7c3bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e7c3bf",
  null
  
)

export default component.exports